module.exports = __webpack_public_path__ + "static/media/icon_21.e49bb8cb.svg";